import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'lodash';
import { NumberUtil } from '../utils/util-function';

type FormatNumberConfigs = {
  symbol?: string;
  appendSymbolAtStart?: boolean;
  formatRule?: string;
  skipZerosAfterDecimal?: boolean;
  round?: boolean;
  postfix?: string;
};

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  private _symbol = '$';
  private _appendSymbolAtStart = true;
  private _formatRule = '1.2-2';
  private _skipZerosAfterDecimal = false;

  transform(value: number | any, configs?: FormatNumberConfigs): string {
    configs = configs || {};
    value = NumberUtil.ToNumber(value);

    if (configs.round) {
      value = round(value, 2);
    }

    let isNegative = value < 0;
    let formattedValue = this.customFormatNumber(value, configs.formatRule || this._formatRule) || '';
    formattedValue = formattedValue.replace(/-/g, '');
    if (configs.symbol || this._symbol) {
      formattedValue = (configs.appendSymbolAtStart === undefined ? this._appendSymbolAtStart : configs.appendSymbolAtStart) ? (configs.symbol || this._symbol) + formattedValue : formattedValue + (configs.symbol || this._symbol);
    }

    if (isNegative) {
      formattedValue = "-" + formattedValue;
    }

    if (configs.skipZerosAfterDecimal || this._skipZerosAfterDecimal) {
      formattedValue = formattedValue.replace('.00', '');
    }

    if (configs.postfix?.length) {
      formattedValue = formattedValue + ' ' + configs.postfix;
    }

    return formattedValue;
  }

  private customFormatNumber(value: number, formatRule: string): string {
    const [integerPart, decimalPart] = value.toFixed(2).split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formattedIntegerPart + '.' + decimalPart;
  }
}
